$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-operating-structure-component .section-options .radio-buttons__option', function () {
    const component = $(this).closest('.clients-momentum-planning-operating-structure-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_operating_structure_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateOperatingStructureSection(id, property, value, component);
  });

  $(document).on('click', '.clients-momentum-planning-operating-structure-component .planned-management-options .radio-buttons__option', function () {
    const component = $(this).closest('.clients-momentum-planning-operating-structure-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_operating_structure_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateOperatingStructureSection(id, property, value, component);
  });

  function updateOperatingStructureSection(id, property, value, component) {
    $.post('/components/clients/momentum_sections/operating_structure', {
      id: id,
      property: property,
      value: value
    }).done(function (data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'operating_structure');
        window.reloadClientTaskBinComponents();
      }

      reloadComponent(component.find('.clients-momentum-task-bin-component'));
    });
  }
});
